import { defaults, get } from 'lodash';
import axios from 'axios';
import cookie from 'vue-cookie';
import def from '../../node_modules/axios/lib/defaults';
import store from '../store';
import * as Account from './Account';

export const CancelToken = () => axios.CancelToken;

export const connection = (options = {}) => {
	def.headers = {
		Authorization: store.getters.getToken,
	};
	def.baseURL = process.env.VUE_APP_API_ADM_EC;
	const instance = axios.create(defaults(def, options));

	// EXECUTADO ANTES DA REQUISIÇÃO NO SERVIDOR
	instance.interceptors.request.use(
		(config) => {
			// VERIFICANDO SE ESTÁ AUTENTICADO
			const hostname = window.location.host;
			const token = cookie.get('admtoken', {
				host: hostname,
			});
			const nConfig = config;
			if (Account.isAuthenticated()) {
				const nUrl = new URL(config.url);
				if (nUrl.search === '') {
					nConfig.url += `?token=${token}`;
				} else {
					nConfig.url += `&token=${token}`;
				}
			}
			return nConfig;
		},
		(error) => Promise.reject(error)
	);

	// EXECUTADO DEPOIS DA REQUISIÇÃO NO SERVIDOR
	instance.interceptors.response.use(
		(response) => {
			const newtoken = get(response, 'headers.authorization');
			if (newtoken) {
				const hostname = window.location.host;
				store.dispatch('setToken', newtoken);
				cookie.set('admtoken', newtoken, {
					host: hostname,
				});
			}
			return response;
		},

		(error) => {
			if (error !== 'Cancel') {
				switch (error.response.status) {
				case 401:
					Account.logoff();
					break;
				case 400:
					Account.logoff();
					break;
				default:
				}
			}

			return Promise.reject(error);
		}
	);

	return instance;
};
